export default function getResource(label) {
    const resources = { pleaseUpdateInfoMessage: 'Please update your information' };

    return resources[label];
}
